import { IPowerBiReportToken } from '@/interfaces/deltaGpt/IPowerBiReportToken.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('deltaGpt');

async function getPowerBiReport (id: string): Promise<IPowerBiReportToken> {
    const endpoint = `/GetPowerBiReportById/${id}`;
    return (await apiCall.get<IPowerBiReportToken>({ endpoint })).data;
}

export const powerBiApi = {
    getPowerBiReport,
};
